export const env: string = "prod"; // dev , prod ,test
export const socketUrl: string =
  env === "prod"
    ? "https://valmiki.templedekho.com/"
    : "https://aiguruji.quarkgen.ai/";

const IMAGEKIT_ENDPOINTS: any = {
  dev: "https://ik.imagekit.io/g1c4xp1uq",
  test: "https://ik.imagekit.io/g1c4xp1uq",
  prod: "https://ik.imagekit.io/tdpimgtag",
};

export const imageKitUrl = IMAGEKIT_ENDPOINTS[env];

export const CLEVERTAP_ACCOUNT_ID: string = "WR5-KWR-867Z";
export const CLEVERTAP_REGION: string = "in1";

export const isCleaverTapEnabled: boolean = true;
